module.exports = __webpack_public_path__ + "static/media/r412.f6b60fdb.jpg";